import React from 'react';
import { TimePicker } from 'antd';
import FormItem from '../FormItem/FormItem';

const TimePickerField = ({
  label,
  name,
  options,
  colon = false,
  form,
  inputProps,
  ...props
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem {...props} colon={colon} label={label}>
      {getFieldDecorator(name, options)(<TimePicker {...inputProps} />)}
    </FormItem>
  );
};

export default TimePickerField;
